import React, { useEffect, useState } from 'react';
import { Form, FloatingLabel } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useReservation } from '../components/ReservationContext';
import { api } from '../components/api';
import StepNavigation from '../components/StepsNavigation';
import { format } from 'date-fns';
import dayjs from 'dayjs';

export default function ContactInfo({ setStepNavigationProps }) {
  const { reservation, setReservation } = useReservation();
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState(reservation.contact.firstName || '');
  const [lastName, setLastName] = useState(reservation.contact.lastName || '');
  const [email, setEmail] = useState(reservation.contact.email || '');
  const [phone, setPhone] = useState(reservation.contact.phone || '');
  const [specialrequest, setSpecialrequest] = useState(reservation.specialrequest || '');

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!firstName.trim()) newErrors.firstName = 'First name is required';
    if (!lastName.trim()) newErrors.lastName = 'Last name is required';

    if (!email.trim()) {
      newErrors.email = 'Valid email is required to send reservation detail';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = 'Valid email is required to send reservation detail';
    }  
  
  if (!phone.trim()) newErrors.phone = 'Phone number is required';

 


    return newErrors;
  };

  const handleContinue = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const updatedContact = { firstName, lastName, email, phone};

    setReservation(prev => ({
      ...prev,
      contact: updatedContact,
      specialrequest: specialrequest
    }));

    const draftPayload = {
      customerDetail: {
        firstName,
        lastName,
        phone,
        email,
      },
      sepcialRequest: specialrequest,
      checkInDate: dayjs(reservation.checkIn).format('YYYY-MM-DD'),
      checkOutDate: dayjs(reservation.checkOut).format('YYYY-MM-DD'),
      adults: reservation.adults,
      children: reservation.children,
      reservationSource: "DIRECT",
      paymentType: "1",
      rooms: reservation.rooms.map(room => ({
        roomType: room.roomType,
        unitsReserved: room.count,
      })),
      reservationCostWithoutTax: reservation.totalBeforeTax
    };

    try {
      setLoading(true);
      const response = await api.post('/reservation/draftreservation', draftPayload);
      const { uuid } = response.data;

      setReservation(prev => ({
        ...prev,
        reservationId: uuid,
      }));

      navigate('/payment', { state: { reservationId: uuid } });
    } catch (err) {
      console.error('Failed to create draft reservation:', err);
      alert('Something went wrong while saving your reservation. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setStepNavigationProps({
      onContinue: handleContinue,
      disableContinue: loading,
      continueLabel: loading ? 'Saving...' : 'Continue',
      backLabel: 'Back',
      onBack: () => navigate('/room'),
      hideBack: false,
    });

    return () => {
      setStepNavigationProps({});
    };
  }, [
    setStepNavigationProps,
    firstName,
    lastName,
    email,
    phone,
    specialrequest,
    loading,
    setReservation,
  ]);

  return (
    <div className="p-3">
      <div className="mb-4">
        <h2 className="h5 fw-semibold text-dark mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          Almost there!
        </h2>
        <p className="text-muted mb-2" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
          Please provide your <strong>name</strong>, <strong>phone number</strong>, and a <strong>valid email address</strong> so we can send your reservation confirmation. You may also include any special requests below.
        </p>
      </div>

      <Form>
        <FloatingLabel controlId="firstName" label="First Name" className="mb-3">
          <Form.Control
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            isInvalid={!!errors.firstName}
            placeholder="First Name"
          />
          <Form.Control.Feedback type="invalid">{errors.firstName}</Form.Control.Feedback>
        </FloatingLabel>

        <FloatingLabel controlId="lastName" label="Last Name" className="mb-3">
          <Form.Control
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            isInvalid={!!errors.lastName}
            placeholder="Last Name"
          />
          <Form.Control.Feedback type="invalid">{errors.lastName}</Form.Control.Feedback>

        </FloatingLabel>

      <FloatingLabel controlId="email" label="Email Address" className="mb-3">
  <Form.Control
    type="email"
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    isInvalid={!!errors.email}
    placeholder="Email"
  />
  <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
</FloatingLabel>


<FloatingLabel controlId="phone" label="Phone Number" className="mb-3">
  <Form.Control
    type="tel"
    value={phone}
    onChange={(e) => {
      const allowed = e.target.value.replace(/[^\d\s()+-]/g, ''); // only allow digits, space, +, -, (, )
      setPhone(allowed.slice(0, 20)); // limit to 20 characters
    }}
    isInvalid={!!errors.phone}
    placeholder="Phone"
    inputMode="tel"
    maxLength={20}
  />
  <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
</FloatingLabel>




        <FloatingLabel controlId="specialrequest" label="Special request" className="mb-3">
          <Form.Control
            type="text"
            value={specialrequest}
            onChange={(e) => setSpecialrequest(e.target.value)}
            placeholder="Special request"
          />
        </FloatingLabel>
      </Form>
    </div>
  );
}
